<template>
    <div id="HomeTabs">
        <div class="mode-switch-container">
            <div 
                class="mode-switch-btn divas" 
                avoid-theme 
                @click="setTheme('divas')" 
                :class="{ active: isDivasTheme }"
            >
                <!-- <div class="img"></div> -->
                <div class="title">Divas</div>
            </div>
            <div 
                class="mode-switch-btn chads" 
                avoid-theme 
                @click="setTheme('chads')" 
                :class="{ active: !isDivasTheme }"
            >
                <!-- <div class="img"></div> -->
                <div class="title">Chads</div>
            </div>
        </div>
        <div class="tabs">
            <div class="tab" :class="{active: activeTabName==='celebrities'}" @click="setTab('celebrities')">Celebrities</div>
            <div class="tab" :class="{active: activeTabName==='outstanding'}" @click="setTab('outstanding')">{{$t('home2021.outstanding')}}</div>
            <div class="tab" :class="{active: activeTabName==='feeds'}" @click="setTab('feeds')">feed</div>
            <div class="tab" :class="{active: activeTabName==='webstars'}" @click="setTab('webstars')">{{$t('header.webstars')}}</div>
            <!-- <div
                v-if="$auth.ready() && $auth.check() && $auth.user().membership_active"
                class="tab"
                :class="{active: activeTabName==='categories'}"
                @click="setTab('categories')"
            >
                DIVAS TV
            </div> -->
        </div>
    </div>
</template>
<script>
import ThemeManager from "../../modules/ThemeManager/ThemeManager.js";

export default {
    name: 'HomeTabs',
    props: {
        activeTabName: {
            type: String,
            default: null
        }
    },
    data(){
        return {
            isDivasTheme: ThemeManager.isDivasTheme()
        }
    },
    methods: {
        setTab(tabName){
            this.$emit('setTab', tabName);
        },
        setTheme(theme){
            //alternamos el tipo de sitio
            ThemeManager.setTheme(theme);
            if (theme === ThemeManager.DIVAS_THEME) {
                this.$emit('setTab', 'banner');
            } else {
                this.$emit('setTab', 'celebrities');
            }
        }
    },
    watch: {
        '$store.state.general.site_type': function(value) {
            this.isDivasTheme = ThemeManager.isDivasTheme();
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/classes';

.tabs{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 0;
    margin-bottom: 15px;
    margin-inline: auto;
    // width: 70%;

    // @media (max-width: 768px) {
        display: flex;
        width: 100%;
        flex-direction: column;
        padding-inline: 1.25em;
    // }
    
    .tab{
        @extend %fresh-btn;

        // display: table-cell;
        // width: 20%;
        min-width: 150px;
        line-height: 2;
        text-align: center;
        vertical-align: middle;
        text-transform: uppercase;
        font-weight: 400;
        cursor: pointer;
        transition: all 200ms ease-in-out;
        padding: unset;
        // border-radius: unset;
        border-radius: 50px;
        color: var(--pallete_clear_text_color) !important;

        // @media (max-width: 768px) {
            display: block;
            width: 100%;
            margin-bottom: 0.5em;
        // }

        @media (min-width: 768px) and (max-width: 858px) {
            font-size: 0.9em;
            min-width: 130px;            
        }

        &.active, &:hover {
            color: var(--pallete_over_main_text_color) !important;
        }
    }

}

.mode-switch-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    // width: 70%;
    margin-block: 15px;
    margin-inline: auto;

    ::selection {
        background: transparent;
    }

    // @media (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
        padding-inline: 1.5em;
    // }

    .mode-switch-btn {
        display: flex;
        flex-direction: column;
        // width: calc((100% - 15px) / 2);
        // min-width: 218px;
        line-height: 2;
        text-align: center;
        text-transform: uppercase;
        font-weight: 1000;
        cursor: pointer;
        transition: all 200ms ease-in-out;
        padding: unset;
        // border-radius: unset;
        // color: var(--pallete_over_main_text_color);

        width: 47%;
        border-radius: 50px;

        .img {
            width: calc(100% - 1em);
            // height: 128px;
            height: 192px;
            margin-top: 0.5em;
            margin-inline: auto;
        }

        &.divas[avoid-theme] {
            border: 1px solid $DIVAS-PALLETE_MAIN_COLOR;
            color: $DIVAS-PALLETE_MAIN_COLOR;

            &.active {
                background-color: $DIVAS-PALLETE_MAIN_COLOR;
                color: $DIVAS-PALLETE_OVER_MAIN_TEXT_COLOR;
            }

            &:hover {
                background-color: lighten($DIVAS-PALLETE_MAIN_COLOR, 5%);
                color: $DIVAS-PALLETE_OVER_MAIN_TEXT_COLOR;
            }
        }

        &.chads[avoid-theme] {
            border: 1px solid $CHAD-PALLETE_MAIN_COLOR;
            color: $CHAD-PALLETE_MAIN_COLOR;

            &.active {
                background-color: $CHAD-PALLETE_MAIN_COLOR;
                color: $CHAD-PALLETE_OVER_MAIN_TEXT_COLOR;
            }

            &:hover {
                background-color: lighten($CHAD-PALLETE_MAIN_COLOR, 7.5%);
                color: $CHAD-PALLETE_OVER_MAIN_TEXT_COLOR;
            }
        }
    }
}
</style>
